<div class="container mt-5">
    <!-- When the visitor is not signed in, show a basic call-to-action to sign up -->
    <div *ngIf="!isAuthenticated">
      <h2>Welcome to All My Hugs!</h2>
      <p>Please sign up to access all of our features.</p>
      <a routerLink="/signup" class="btn btn-primary">Please Sign Up</a>
    </div>
    
    <!-- For signed-up users (role: user) -->
     
    <div *ngIf="isAuthenticated && !hasRole('paiduser') && !hasRole('admin') && !hasRole('recipient')">
      <h2>Welcome, {{ username }}!</h2>
      <p>This is content available to users who have signed up. Enjoy exploring our site!</p>

      <br /><br />What you can do here as a free user.
  <!-- Add additional features for standard users here -->
     </div> 
  
    <!-- For paid members -->
    <div *ngIf="isAuthenticated && hasRole('paiduser')">
      <h2>Welcome, Paid Member {{ username }}!</h2>
      <p>As a paid member, you have access to exclusive features and contentzs.</p>
      <!-- Add paid-member specific content here -->
    </div>
  
    <!-- For admin users -->
    <div *ngIf="isAuthenticated && hasRole('admin')">
      <h2>Admin Dashboard for {{ username }}</h2>
      <p>Use the tools below to manage the site and view administrative data.</p>
      <!-- Add admin-specific controls and tools here -->
    </div>
  
    <!-- For recipient users (remember: a recipient may also be a paid user; if a user is both, you might show combined content) -->
    <div *ngIf="isAuthenticated && hasRole('recipient')">
      <h2>Recipient Portal for {{ username }}</h2>
      <p>This section provides content and tools specifically for recipients of our service.</p>
      <!-- Add recipient-specific features or combined features if needed -->
    </div>
  </div>
  